var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-step"},[_c('van-steps',{attrs:{"active":_vm.active,"active-icon":"success","active-color":"#38f"}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('van-step',[_vm._v(_vm._s(item.value))])],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }